

export const formatAddress = (
  address,
  startChars = 4,
  endChars = 4
) => {
  return address.slice(0, startChars) + '...' + (endChars === 0 ? "" :address.slice(-endChars));
};
